module.exports = __webpack_public_path__ + "static/media/Panspot.210b334d.svg";